import { useEffect } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { errMsg, fmtDate, openFile } from "../lib/api";
import { useApi, PageHeader, Empty, Loading, btn, SampleBadge } from "../components/kit";
import { DueChip, PolicyAckCard } from "../components/PolicyAck";

export default function Policies() {
  const { data, loading } = useApi("/policies");
  const mine = useApi("/my/policies");
  useEffect(() => {
    if (!loading && !mine.loading && window.location.hash) document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  }, [loading, mine.loading]);
  if ((loading && !data) || (mine.loading && !mine.data)) return <Loading />;
  const live = (data || []).filter((p) => p.current);
  const my = Object.fromEntries((mine.data || []).map((x) => [x.policy_id, x]));
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Library" title="Policies" testid="policies-header" />
      {live.length === 0 ? <Empty testid="policies-empty">No policies have been published yet.</Empty> : (
        <div className="grid gap-3">{live.map((p) => (
          <div key={p.id} id={`p-${p.id}`} className={`scroll-mt-24 rounded-xl border bg-white p-4 ${my[p.id] && !my[p.id].acknowledged ? "border-[color:var(--dcbc-red)]/40" : ""}`} data-testid={`policy-${p.id}`}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <div className="flex-1">
                <p className="font-semibold flex flex-wrap items-center gap-2">{p.title} <SampleBadge show={p.is_demo} />{my[p.id] && <DueChip x={my[p.id]} />}</p>
                <p className="text-sm text-muted-foreground">{p.category || "General"} · Version {p.current.version} · Effective {fmtDate(p.current.effective_date)} · Approved by {p.current.approver} on {fmtDate(p.current.approval_date)}</p>
              </div>
              {!(my[p.id] && !my[p.id].acknowledged) && <button className={btn.ghost} onClick={() => openFile(p.current.file_id).catch((e) => toast.error(errMsg(e)))} data-testid={`policy-open-${p.id}`}><FileText className="h-4 w-4" /> Open</button>}
            </div>
            {my[p.id] && <div className="mt-4 border-t pt-4"><PolicyAckCard x={my[p.id]} reload={mine.reload} /></div>}
          </div>))}</div>)}
    </div>
  );
}
